import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Service from '../../../apis/service';
import { ErrorToast } from '../../utils/Utils';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import {
  getJourneyList,
  getJourneyDetails,
  showProgress,
  getTagList,
  getCapstoneDetails,
} from '../../../redux/actions/DealershipActions';
import { updateIsSelectedTrue } from '../utils';

const useFetchData = () => {
  const dispatch = useDispatch();
  const [collectionList, setCollectionList] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [rules, setRules] = useState([]);
  const [selectedRule, setSelectedRule] = useState([]);
  const [mandatoryRuleCoditions, setMandatoryRuleCoditions] = useState({});

  const getCollections = useCallback(async () => {
    try {
      dispatch(showProgress(true));
      const res = await Service.get(apiEndpoints.JOURNEY_COLLECTION_LIST);
      const temp = res?.map((item) => ({
        value: item.id,
        label: item.title,
        isDisable: item.disabled?.isDisabled,
        msg: item.disabled?.message,
      }));
      temp?.sort((a, b) => b.value - a.value);
      setCollectionList(temp);
      dispatch(showProgress(false));
    } catch (e) {
      ErrorToast(e);
      dispatch(showProgress(false));
    }
  }, [dispatch]);

  const fetchJourneysList = useCallback(
    async (initial) => {
      try {
        dispatch(showProgress(true));
        const response = await Service.get(apiEndpoints.GET_JOURNEYS_LIST);
        dispatch(getJourneyList('fetch', response));
        dispatch(showProgress(false));
        if (typeof initial === 'function') {
          if (response.length > 0) {
            initial(0, response[0]?.id);
          }
        }
      } catch (error) {
        ErrorToast(error);
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  const getJourneyDetail = useCallback(
    async (id, boolVal) => {
      try {
        if (boolVal !== undefined) {
          dispatch(showProgress(true));
          const p1 = Service.get(apiEndpoints.JOURNEY_BY_ID.replace('ID', id), '');
          const p2 = Service.get(apiEndpoints.JOURNEY_DEPARTMENTS.replace('ID', id));
          const p3 = Service.post(apiEndpoints.JOURNEY_LIST, { journeyId: id });
          const p4 = Service.get(apiEndpoints.JOURNEY_COLLECTION_LIST);
          const res = await Promise.all([p1, p2, p3, p4]);
          dispatch(getJourneyDetails('updateJourneyDetails', res[0]));
          if (res[0]?.levels?.length === 0) {
            dispatch(getCapstoneDetails('delete', []));
          }
          if (boolVal) {
            const temp = updateIsSelectedTrue(res[1]);
            setDepartments(temp);
          } else {
            setDepartments(res[1]);
          }
          setSelectedRule(res[2].selectedRule);
          setRules(res[2].list || []);
          setMandatoryRuleCoditions(res[2]?.mandatoryRuleCoditions);
          const temp = res[3]?.map((item) => ({
            value: item.id,
            label: item.title,
            isDisable: item.disabled?.isDisabled,
            msg: item.disabled?.message,
          }));
          temp?.sort((a, b) => b.value - a.value);
          setCollectionList(temp);
          dispatch(showProgress(false));
        }
      } catch (err) {
        ErrorToast(err);
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );
  const getTags = useCallback(async () => {
    await Service.get(apiEndpoints.JOURNEY_TAG_JOURNEY, '')
      .then((response) => {
        dispatch(getTagList(response));
      })
      .catch((error) => {
        console.log(error);
      });
  }, [dispatch]);
  return {
    mandatoryRuleCoditions,
    collectionList,
    departments,
    rules,
    selectedRule,
    setMandatoryRuleCoditions,
    setDepartments,
    getJourneyDetail,
    getCollections,
    getTags,
    fetchJourneysList,
  };
};

export default useFetchData;
